import axios from '../utils/axios'

const api = {
    statistics: '/api/users/credit/record/statistics',
    users: '/api/users',
    platforms: '/api/user/platforms',
    userBrands: '/api/userBrands',
    creditStatistics: '/api/statistics/credit/index'
}

/**
 * 统计当前用户信誉分，根据标签分组统计
 * @returns {Promise<any>}
 */
export function fetchStatistics () {
    return new Promise((resolve, reject) => {
        axios.get(api.statistics)
            .then(response => {
                console.log(response, '信誉分')
                if (typeof response.config === 'undefined') {
                    resolve(response.data)
                } else {
                    resolve(response.data.data)
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 用户详情
 * @returns {Promise<any>}
 */
export function fetchUsers () {
    return new Promise((resolve, reject) => {
        axios.get(api.users)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 查询列表
 * @returns {Promise<any>}
 */
export function fetchPlatforms () {
    return new Promise((resolve, reject) => {
        axios.get(api.platforms)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 查询列表
 * @param params {Object}
 * @returns {Promise<any>}
 */
export function fetchUserBrands (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.userBrands, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 信誉统计页面统计（曝光量）
 * @returns {Promise<any>}
 */
export function fetchCreditStatistics () {
    return new Promise((resolve, reject) => {
        axios.get(api.creditStatistics)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
